import React, { useEffect } from 'react'
import { Modal, Image, Divider, message } from 'antd'
import { orderService } from '../../orderService'
import { imgTeamLists, imgCustomerLists } from '@/types/AppEnums'
import { vehicleDetialModel } from './vehicleDetialModel'

const ImgModal = ({ modalData, setModalData, orderId }) => {
    const { imageClassifyList, setImageClassifyList } = vehicleDetialModel()
    useEffect(() => {
        if (modalData.visible) {
            initClassifyData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalData])

    const initClassifyData = () => {
        let list = modalData.repairMode === 'customer' ? imgCustomerLists : imgTeamLists
        let imageClassifyList = list.sort(function (a, b) {
            return b.required - a.required
        })
        setImageClassifyList(imageClassifyList)
        let data: any = {
            imageGroup: modalData.repairMode,
            pageNum: 1,
            pageSize: 100,
            id: orderId,
            // id:"c604ad81d1484a54a54781de5c726326",
        }
        orderService
            .getImageClassifyList(data)
            .then((res: any) => {
                let imageList: any = []
                if (res.retData.records.length === 0) {
                    message.warning('本条工单并无照片显示')
                    setModalData({ visible: false, repairMode: '' })
                }
                imageClassifyList.forEach((item: any) => {
                    let images: any = res.retData.records.filter((i) => i.attachmentType === item.imageCode)
                    let fileList: any = []
                    if (images.length > 0) {
                        item.file = images.map((ele) => {
                            const { attachmentMd5: MD5 } = ele
                            const url: any = `https://file-server.yunhaochefu.com/image/${MD5}`
                            imageList.push(url)
                            fileList.push({
                                uid: MD5,
                                id: ele.id,
                                status: 'done',
                                url,
                                isHas: true,
                            })
                            return {
                                url,
                                MD5,
                                ...ele,
                            }
                        })
                    }
                    item.fileList = fileList
                })
                setImageClassifyList([...imageClassifyList])
            })
            .catch((error) => {
                console.log('error: ', error)
            })
    }

    return (
        <Modal
            width={1000}
            bodyStyle={{ height: 660, overflowY: 'auto' }}
            onCancel={() => {
                setModalData({ visible: false, repairMode: '' })
            }}
            visible={modalData.visible}
            title={modalData.repairMode === 'customer' ? '故障图片查看' : '维修团队现场图片查看'}
            footer={null}
        >
            {imageClassifyList.map((item) => {
                return (
                    <div key={item.id}>
                        {item.fileList?.length > 0 ? (
                            <div>
                                <div style={{ color: '#385ddd' }}>{item.imageName}:</div>
                                <div style={{ backgroundColor: 'rgb(242 242 242)', padding: '5px' }}>
                                    <Image.PreviewGroup>
                                        {item.fileList?.map((e) => (
                                            <Image src={e.url} width={90} style={{ height: '100%', padding: '2px 2px' }} />
                                        ))}
                                    </Image.PreviewGroup>
                                </div>
                                <Divider />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                )
            })}
        </Modal>
    )
}

export default ImgModal
